<template>
    <div class="service-package">
        <ServicePackageHeader :addon="addon" />
        <ServicePackageUSPList :usps="usps" :name="addon.name" :link="addon.link" />
    </div>
    <ServicePackageFooter :addon="addon" :isSelected="isSelected" @select="onSelect" />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import {
        ServicePackage,
        ServicePackageUSP,
    } from '@ui/components/ServicePackage/ServicePackage.interfaces';
    import ServicePackageHeader from './Header/ServicePackageHeader.vue';
    import ServicePackageFooter from './Footer/ServicePackageFooter.vue';
    import ServicePackageUSPList from './USP/ServicePackageUSPList.vue';

    export default defineComponent({
        name: 'ServicePackageCard',
        components: {
            ServicePackageHeader,
            ServicePackageUSPList,
            ServicePackageFooter,
        },
        props: {
            addon: {
                type: Object as PropType<ServicePackage>,
                required: true,
            },
            usps: {
                type: Array as PropType<ServicePackageUSP[]>,
                required: true,
            },
            isSelected: { type: Boolean, default: false },
            modelValue: {
                type: Boolean as PropType<boolean | undefined>,
                default: undefined,
            },
        },
        emits: ['update:modelValue'],
        setup(_, { emit }) {
            function onSelect(state: boolean) {
                emit('update:modelValue', state);
            }

            return {
                onSelect,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './ServicePackage.scss';
</style>
